import React from 'react'; // Import React
import styled, { useTheme } from 'styled-components'; // Import useTheme
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';
import { useTranslation } from 'react-i18next'; // Import useTranslation

const GMAP_KEY = process.env.REACT_APP_GMAP_KEY;

const MapOuterContainer = styled.div` // Renamed from MapContainer to avoid conflict with mapContainerStyle prop name
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
`;

// mapContainerStyle is now generated inside the component to access theme

const center = {
  lat: 40.497167,
  lng: -76.210099,
};

const options = {
  disableDefaultUI: true,
  zoomControl: true,
};

const Map: React.FC = () => { // Changed to React.FC
  const theme = useTheme(); // Access theme
  const { t } = useTranslation(); // Initialize useTranslation
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GMAP_KEY || "", // Ensure GMAP_KEY is not undefined
  });

  const mapContainerStyle = { // Define inside component to use theme
    width: '100%', // Fill the styled outer container
    height: '100%',
    borderRadius: theme.borderRadius,
  };

  if (loadError) return <div>{t('contact.mapError')}</div>;
  if (!isLoaded) return <div>{t('contact.mapLoading')}</div>;
  return (
    <MapOuterContainer> {/* Use the styled div */}
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={14}
        center={center}
        options={options}
      >
        <Marker position={center} />
 </GoogleMap>
 </MapOuterContainer>
  );
}

export default Map;
